<template>
  <InfoPageContainer v-bind="{ id, type, value }" hide-prizes>
    <template #header>
      <HighFrequencyGameHeader />
    </template>
  </InfoPageContainer>
</template>

<script lang="ts" setup>
import { CUSTOM_INFO_ROUTES, INFO_ROUTE_TYPES } from '~/constants/infoRoutes'

definePageMeta({
  key: 'keno-info',
  layout: false,
  middleware: ['info-redirect'],
  validate: async (to) => {
    try {
      const licensedTerritory = useLicensedTerritory({ raw: true })
      const gameId = useHighFrequencyGamesOfLicensedTerritory().getHighFrequencyGameIdInCorrectCase(
        to.params.gameId,
      )

      await useHighFrequencyGameConfigLazyQuery({
        gameId,
        licensedTerritory,
      }).load()

      return validateInfoRouteCreator([CUSTOM_INFO_ROUTES.Rules, CUSTOM_INFO_ROUTES.Faq])(to)
    } catch {
      return false
    }
  },
})

const router = useRouter()

const id = computed(() => String(router.currentRoute.value.params.gameId))
const type = computed(() => INFO_ROUTE_TYPES.HighFrequencyGame)
const value = computed(() => String(router.currentRoute.value.params.id))
</script>
